import { useCallback } from 'react';
import {
	fireOperationalAnalyticsDeferred,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

export const useIssueTransitionsOperationalAnalyticsEvent = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const fireOperationalEventIssueTransitionFieldsCount = useCallback(
		({ actionSubject, fieldCount }: { actionSubject: string; fieldCount: number }): void => {
			const analyticsEvent = createAnalyticsEvent({});
			fireOperationalAnalyticsDeferred(analyticsEvent, actionSubject, { fieldCount });
		},
		[createAnalyticsEvent],
	);

	const fireOperationalAnalyticsPermissionsUnAvailable = useCallback(
		({ actionSubject }: { actionSubject: string }): void => {
			const analyticsEvent = createAnalyticsEvent({});
			fireOperationalAnalyticsDeferred(analyticsEvent, actionSubject);
		},
		[createAnalyticsEvent],
	);

	const fireOperationalAnalyticsTransitionScreenOpened = useCallback(
		({
			actionSubject,
			isBenefitsModalFGEneabled,
			preferNewIssueTransitionScreen,
			issueViewAnalyticsSource,
			isBenefitsModalDisabled,
			dateToShowBenefitsModal,
		}: {
			actionSubject: string;
			isBenefitsModalFGEneabled?: boolean;
			preferNewIssueTransitionScreen?: boolean;
			issueViewAnalyticsSource?: string;
			isBenefitsModalDisabled?: boolean;
			dateToShowBenefitsModal?: string | undefined;
		}): void => {
			const analyticsEvent = createAnalyticsEvent({});
			fireOperationalAnalyticsDeferred(analyticsEvent, actionSubject, {
				isBenefitsModalFGEneabled,
				preferNewIssueTransitionScreen,
				issueViewAnalyticsSource,
				isBenefitsModalDisabled,
				dateToShowBenefitsModal,
			});
		},
		[createAnalyticsEvent],
	);

	return {
		fireOperationalEventIssueTransitionFieldsCount,
		fireOperationalAnalyticsPermissionsUnAvailable,
		fireOperationalAnalyticsTransitionScreenOpened,
	};
};
